import React, { useRef } from "react";
import { View, TextInput } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { useChat } from "../../context/ChatContext";
import { ChatData } from "../../context/ChatContext";
import { StreamActionIcon } from "../StreamActionIcons";

const ChatMessageInput = ({ newMessage, setNewMessage }) => {
  const styles = useStyles();
  const inputRef = useRef<TextInput>(null);
  const { sendMessage, userData, currentChat, setChats } = useChat();

  const handleSendMessage = () => {
    if (newMessage.trim() && userData && currentChat) {
      const messageContent = newMessage.trim();

      sendMessage(
        currentChat.conversationId,
        userData.username,
        messageContent,
        userData.accessToken
      );

      setNewMessage("");

      setChats((prevChats: ChatData[]) =>
        prevChats.map((chat) =>
          chat.conversationId === currentChat.conversationId
            ? {
                ...chat,
                lastMessageUser: userData.username,
                lastMessage: messageContent,
                lastMessageTimestamp: Date.now(),
                lastMessageRead: false,
              }
            : chat
        )
      );
    }
  };

  return (
    <View style={[styles.container]}>
      <TextInput
        ref={inputRef}
        style={[
          AppFontStyle.REGULAR_ANYBODY_14,
          {
            flex: 1,
            backgroundColor: "white",
            borderRadius: 10,
            paddingHorizontal: 7,
            paddingVertical: 15,
            color: "black",
          },
        ]}
        placeholderTextColor="#989898"
        placeholder="Write your message..."
        value={newMessage}
        onChangeText={setNewMessage}
        onSubmitEditing={() => {
          handleSendMessage();
          setTimeout(() => inputRef.current?.focus(), 100);
        }}
        returnKeyType="send"
      />
      <View style={{ marginLeft: 10, opacity: newMessage === "" ? 0.5 : 1 }}>
        <StreamActionIcon
          type="send"
          onPress={() => {
            if (newMessage !== "") {
              handleSendMessage();
              inputRef.current?.focus();
            }
          }}
        />
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: "100%",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        width: "100%",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        width: "100%",
      },
    },
  }
);

export default withErrorBoundary(ChatMessageInput);
